import NavUnderline from '../components/NavUnderline';

document.querySelectorAll('.main-nav').forEach(el => new NavUnderline(el));

document.querySelectorAll('.filter').forEach(el => new NavUnderline(el, {
    namespace: 'filter',
}));
